import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {CookiesProvider} from 'react-cookie';
import ReactDOM from 'react-dom/client';
import 'react-image-crop/dist/ReactCrop.css';
import {QueryClient, QueryClientProvider} from 'react-query';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import {AuthProvider} from './context/authContext';
import AxiosInterSeptorProvider from './context/publicModalContext';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import AppRoutes from './routes';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {store} from './store/redux';
import AppErrorBoundary from './utilities/protection/AppErrorBoundary';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});
const contextClass = {
  success: 'bg-green-50 border-[2px] border-green-500 text-gray-950',
  error: 'bg-red-600',
  info: 'bg-gray-600',
  warning: 'bg-orange-400',
  default: 'bg-indigo-600',
  dark: 'bg-white-600 font-gray-300',
};

const customIcons = {
  success: (
    <SpanIcon className="text-green-500 icon-nameCheck-circle1 text-20px" />
  ),

  error: (
    <SpanIcon className="text-green-500 icon-nameCheck-circle1 text-20px" />
  ),
  info: <SpanIcon className="text-green-500 icon-nameCheck-circle1" />,
  warning: <SpanIcon className="text-green-500 icon-nameCheck-circle1" />,
  default: <SpanIcon className="text-green-500 icon-nameCheck-circle1" />,
  dark: <SpanIcon className="text-green-500 icon-nameCheck-circle1" />,
};

// mobile console.log
// const VConsole = require('vconsole');
// new VConsole();
window.addEventListener('error', e => {
  if (
    /Loading chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i.test(
      e.message || '',
    )
  ) {
    if (!sessionStorage.getItem('chunk-reload-attempted')) {
      sessionStorage.setItem('chunk-reload-attempted', '1');
      window.location.reload();
    }
  }
});

window.addEventListener('unhandledrejection', e => {
  const msg = String((e.reason && e.reason.message) || e.reason || '');
  if (/ChunkLoadError|Loading chunk [\d]+ failed/i.test(msg)) {
    if (!sessionStorage.getItem('chunk-reload-attempted')) {
      sessionStorage.setItem('chunk-reload-attempted', '1');
      window.location.reload();
    }
  }
});
window.addEventListener('vite:preloadError', forceReload); // if you ever move to Vite

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

function forceReload() {
  if (sessionStorage.getItem('chunk-reload-attempted')) return; // avoid infinite loop
  sessionStorage.setItem('chunk-reload-attempted', 'true');
  window.location.reload();
}

root.render(
  // <React.StrictMode>
  <AppErrorBoundary>
    <CookiesProvider>
      <AxiosInterSeptorProvider>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <AuthProvider>
                <ToastContainer
                  closeButton={({type}) => (
                    <SpanIcon className="icon-nameClose-remove text-[20px] text-gray-950 pl-3" />
                  )}
                  icon={({type}) => customIcons[type || 'default']}
                  hideProgressBar
                  autoClose={5000}
                  position="bottom-center"
                  rtl={true}
                  toastClassName={context =>
                    contextClass[context?.type || 'default'] +
                    ' relative flex p-1 bottom-[60px] min-h-10 rounded-md justify-between overflow-hidden cursor-pointer'
                  }
                />
                <AppRoutes />
              </AuthProvider>
            </BrowserRouter>
          </QueryClientProvider>
        </Provider>
      </AxiosInterSeptorProvider>
    </CookiesProvider>
  </AppErrorBoundary>,
  // </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
